<template>
  <div class="page adminpage editproductpage">
    
      <div class="product-header">

        <div class="p-meta">
          <h1><i class="icon icon-projects"></i>Produkt <span class="notbold" >{{articlenumber}}</span></h1>
         
         <div class="actions">
             <a v-on:click="save"><i class="icon icon-save"></i><span>Speichern</span></a>
             <a v-on:click="saveandback"><i class="icon icon-save"></i><span>Speichern & schließen</span></a>
<!--              <a v-on:click="deleteProject"><i class="icon icon-plus" ></i><span>Projekt löschen</span></a> -->
         </div>
         
        </div>
      </div>
    
    

    <div class="columns max flex wrap productinfoedit">
        <div class="column">
            <h3>Produkt</h3>
          <div class="inputfiled-container">
            <label>Artikelnummer</label>
            <input v-model="articlenumber" type="text" :readonly="id > 0 ">
          </div>
          <div class="inputfiled-container">
            <label>Aktiv?</label>
            <input type="checkbox" v-model="attributes.active"> <span> JA</span>
          </div>
          <div class="inputfiled-container">
            <label>Featrued?</label>
            <input type="checkbox" v-model="attributes.featured"> <span> JA</span>
          </div>

          <div class="farbwelten-edit farbwelten">
              <div v-for="color in config.product.colors" :key="color.id" class="farbwelt">
                  <input type="checkbox" v-model="colors" :checked="colors.includes( color )" :id="'g-e-'+color.id" :name="color.id" :value="color" />
                    <label :class="'gradient ' + color.id" :for="'g-e-'+color.id"></label> <span>{{color.name}}</span>
                    
                </div>
          </div>
          
          
          <div class="properties-edit properties" >
            <div class="inputfiled-container3">
              <div v-for="property in config.product.properties" :key="property.id" >
                <h3>{{property.name}}</h3>
                <div v-for="value in property.values" :key="value.id" >
                    <input :type="property.type" :id="value.id" :value="value.id" v-model="properties[property.id]">  &nbsp; 
                    <label :for="value.id">{{value.name}} </label>
                </div>
              </div>
            </div>
          </div>
          
          
          <div class="inputfiled-container">
            <label>Name</label>
            <input v-model="attributes.name" type="text">
          </div>
          <div class="inputfiled-container">
            <label>Info / Beschreibung</label>
            <textarea v-model="attributes.info"></textarea>
          </div>

 

        </div>
        <div class="column">
          <h3>Bilder</h3>
          
            
            <draggable v-model="attributes.images" group="allimgs" @start="drag=true" @end="drag=false" class="image-list">

            <div class="image-container" v-for="(image, i) in attributes.images" :key="i">
              <div class="image">
                <img loading="lazy" :src="config.appUrl + image.url">
                <div class="deleteImage" v-on:click="deleteImage(i)"></div>
              </div>
            </div>
            
            </draggable>
            
          <dobetter-uploader v-bind:articlenumber="articlenumber" v-if="id" v-bind:uploadedImages.sync="attributes.images" ></dobetter-uploader>

          
        </div>
    </div>
  </div>
</template>
<script>
    import config from '../_config/config';
    import dobetterUploader from '../components/dobetterUploader';
    import draggable from 'vuedraggable'
    //import config from '../_config/config';

  export default {
    name: 'Product',
    components: {
      dobetterUploader,
      draggable
    },    
    data: function(){
                return {
                      properties: { stonetype: [], surface: '', format: ''},
                      colors:[],
                      images: [],
                      config: null,
                      id: null,
                      articlenumber: null,
                      attributes: { 
                        name: '',
                        info: '',
                        images: [],
                        properties: {},
                        active: true,
                        featured: false,
                        colors: this.colors
                      },
/*
                      product: {
                        id: null,
                        articlenumber: null,
                        attributes: { 
                          name: '',
                          info: '',
                          images: [],
                          properties: {},
                          active: true,
                          featured: false,
                          colors: []
                        }
                      },
*/
                      p1: {}
                  }
            },

    watch: {
      
            $data: {
                handler: function(val, oldVal) {
                    //console.log(val)
                },
                deep: true
        },      
      
//    '$route.params.articlenumber': function (articlenumber) {
      //this.filterResults()
 //     },
      'products' : function(products) {
                       this.getProduct()
                      },
      //'attributes.images' : function(){ console.log('autosave'); this.save() }
      //'stonetype' : function(){ console.log( this.stonetype );  },
      //'properties.stonetype' : function(){ console.log( this.properties );  },
      //'attributes.properties.stonetype' : function(){ console.log( this.attributes.properties );  }

    },
    mounted: function() {
       
    }, 
    computed: {

        products () {
          return this.$store.state.products.all
        },               
/*
        product() {
          
        },
*/
        user () {
            return this.$store.state.authentication.user
        },
        getSavedProduct () {
          return this.$store.state.products.saved
        },


    },
               
    created: function(){
        //console.log('created');
        this.$store.dispatch('products/getAll');
        this.config = config
         
        //this.getProduct();
        },  
        
    methods: {
      getProduct(){
          
          let articlenumber = this.$route.params.articlenumber
          console.log( articlenumber );
          if(  articlenumber == null ) return
           //this.articlenumber = articlenumber;

           let p1 = this.products.filter( ( item ) => {
              return ( item.articlenumber == this.$route.params.articlenumber ) 
            });   



            if( p1.length > 0 ) {
                        
              console.log( p1[0] );
             
              if( p1[0].attributes.colors && p1[0].attributes.colors.length > 0 ) 
                      this.colors = p1[0].attributes.colors;

              this.id             = p1[0].id
              this.articlenumber  = p1[0].articlenumber
              this.attributes     = p1[0].attributes
              
              if(p1[0].attributes.properties)
              this.properties     = p1[0].attributes.properties
              //console.log(  p1[0].attributes.properties );
            }
            
      },
      saveandback(){
            this.submitted = true;
            this.attributes.colors = this.colors
            this.attributes.properties = this.properties
            //this.attributes.images = this.images

            //console.log(this.attributes);
            const { id, articlenumber, attributes } = this;
            const { dispatch } = this.$store;
            if (articlenumber && attributes) {
                dispatch('products/save', { id, articlenumber, attributes })
                  .then( (res ) => {
                    
                      if( res.last_insert_id > 0)
                      this.id = this.getSavedProduct.last_insert_id
                      
                      this.$router.push({ name: 'AdminPage' })
                      
                  });
                
            }
        },

      save(){
            this.submitted = true;
            this.attributes.colors = this.colors
            this.attributes.properties = this.properties
            //this.attributes.images = this.images

            //console.log(this.attributes);
            const { id, articlenumber, attributes } = this;
            const { dispatch } = this.$store;
            if (articlenumber && attributes) {
                dispatch('products/save', { id, articlenumber, attributes })
                  .then( (res ) => {
                    
                      if( res.last_insert_id > 0)
                      this.id = this.getSavedProduct.last_insert_id
                      
                      //this.$router.push({ name: 'AdminPage' })
                      
                  });
                
            }
        },
        deleteImage(i){
          this.attributes.images.splice(i,1)
        },



      },
    }

</script>
<style scoped>
  
  .editproductpage { position: relative; padding: 9rem 0 9.88888em 0; height: 100%; min-height: 100vh; }

  .editproductpage .product-header { padding: 0.73333em 0.73333em 0.73333em 1.866em; }
  
  
  .editproductpage .inputfiled-container { display: flex; flex-wrap: wrap; padding: 0.933333em 0; align-items: center; }
  .editproductpage .inputfiled-container { padding: 0.933333em 0; width: 100%;  }
  .editproductpage label { display: inline-block; flex: 1 1 30%; max-width: 30%; }
  .editproductpage input[type="text"] { flex: 1 1 65%; max-width: 65%; border: 0; border-bottom: 1px solid #787878; background: transparent; outline: none !important; color: #fff; padding: 0.43333em 0; }
  .editproductpage input[readonly="readonly"] { background: url(/img/icons-red/lock.svg) right center no-repeat; background-size: 1.4333em;  }
  .editproductpage textarea { flex: 1 1 65%; max-width: 65%; border: 1px solid #787878; background: transparent; outline: none !important; color: #fff; min-height: 5em; }
  .button { display: block; padding: 0.33333em 0.9333333em; background: transparent; border: 2px solid #fff; color: #fff;}

  @media screen and ( min-width: 768px) {    
  .editproductpage .columns .column { flex: 1 1 50%; max-width: 50%; }
  }

  .image-list { display: flex; flex-wrap: wrap; width: 100%; border: 0 solid red; padding: 0 0 1.43333em 0; }
  .image-list .image-container { flex: 1 1 49%; max-width: 49%; padding: 0.63333em; margin: 0 1% 1% 0; align-items: stretch; background: rgba(0,0,0,0.2); border-radius: 4px;}
  .image-list .image { display: block; width: 100%; height: auto; overflow: hidden; position: relative; }
  .image-list .image img { display: block; object-fit: cover; position: relative; z-index: 3; }

  .image-list .image:before { position: absolute; top: 0.63333em; left: 0.633333em; z-index: 4; content:""; 
      width: 2.333em; height: 2.333em; line-height: 2.333em; text-align: center; border-radius: 3px;
      background: rgba(255,255,255,0.2) url(/img/icons-custom-white/move.svg) center center no-repeat; background-size: 70%;
      cursor: move;
      }

   .image-list .image .deleteImage { position: absolute; z-index: 4; right: 0.633333em; top: 0.63333em; height: 2.33333em; width: 2.333em; line-height: 2.3333em;
     background: rgba(0,0,0,0.5) url(/img/icons-white/bin.svg) center center no-repeat; background-size: 70%; border-radius: 3px;
     transition: background-color 0.3s;
      }

   .image-list .image .deleteImage:hover { background-color: #dc1200; }

  @media screen and ( min-width: 768px) {  
  .image-list .image-container { flex: 1 1 49%; max-width: 49%; }


  }


  .editproductpage .inputfiled-container2 { display: inline-block; width: 50%; padding: 0 0.93333em 0 0; }
/*
  .farbwelten-edit label { height: 2.1777rem; width: 5.777rem; text-indent: 0; 
      border: 0 solid #fff; display: block; position: relative; max-width: 100%; width: 100% !important; margin: 0; 
      }
  .farbwelten-edit label:after { position: absolute; right: 0; top: 0; height: 2.1777rem; line-height: 2.1777rem; text-align: center;  width: 1.8777rem; content: "\2717"; text-indent: 0; background: none; color: #dc1200; border-radius: 0 5px 5px 0; 
    transition: background 0.3s ease;
  }
  .farbwelten-edit input { display: none; }
  .farbwelten-edit input:checked + label:after { background: none; color: #52a400; content: "\2714" }
*/
/*   .farbwelten-edit input + label:after { content:"ok"; background: green; } */



  .farbwelten-edit label { height: 1.9777rem; width: 5.777rem; text-indent: 0; 
      border: 0 solid #fff; display: block; position: relative; max-width: 100%; width: 100% !important; margin: 0; z-index: 99;
      }
  .farbwelten-edit label:after { position: absolute; left: 0.1433rem; top: 0.1433rem; height: 1.6777rem; line-height: 1.6777rem; text-align: center;  width: 1.6777rem; content: "\2717"; text-indent: 0; 
    background: rgba(0,0,0,0.6); border: 0 solid rgba(0,0,0,0.1); color: #fff; border-radius: 3px; 
    transition: background 0.3s ease;
    z-index: 2;
    z-index: 100;
    box-shadow: 0 0 2px rgba(0,0,0,0.4);
  }

  .farbwelten-edit input { display: none; }
  .farbwelten-edit input:checked + label:after { content: "\2714";  color: #fff; background: #52A400; }

  .farbwelten { display: flex; flex-wrap: wrap; }
  .farbwelt { flex: 1 1 49%; max-width: 50%; display: flex; margin: 0 0.333em 0.3333em 0; background: rgba(0,0,0,0.6); border-radius: 2px; overflow: hidden; }
  .farbwelt label { display: block; flex: 0 0 35%; max-width: 35%; }
  .farbwelt span { display: block; flex: 0 0 60%; max-width: 60%; height: 1.9777rem; line-height: 1.9777rem; padding: 0 0.9333rem; font-size: 0.9rem; }





  .editproductpage .inputfiled-container3 { display: block; }
  .editproductpage .inputfiled-container3 label { display: inline-block; max-width: 100%; }

  .editproductpage .productinfoedit .column { padding: 0.933333em; margin: 0.93333em 0.3333em 0 0.93333em; background: rgba(255,255,255,0.1); border-radius: 3px;}

  .notbold { font-weight: normal !important; }
  
  

</style>